export default "__VITE_ASSET__CmcPKzqY__"